/* Copy do detalhe de usuário: cabeçalho (trilha + estados) e abas. "Orgs"/"Devices"/"Licenses"
   já são os termos usados no produto em pt-BR (empréstimo comum em painéis admin) — mantidos
   iguais nos dois idiomas de propósito, não são um esquecimento de tradução. */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface UserDetailContent {
  readonly breadcrumbAriaLabel: string;
  readonly usersBreadcrumb: string;
  readonly userFallbackLabel: string;
  readonly loadError: string;
  readonly tabs: {
    readonly overview: string;
    readonly orgs: string;
    readonly devices: string;
    readonly licenses: string;
    readonly sessions: string;
    readonly audit: string;
  };
  readonly dimensionUnavailable: {
    readonly devices: string;
    readonly licenses: string;
    readonly sessions: string;
  };
}

const USER_DETAIL_CONTENT: Bilingual<UserDetailContent> = {
  'pt-BR': {
    breadcrumbAriaLabel: 'Trilha',
    usersBreadcrumb: 'Usuários',
    userFallbackLabel: 'Usuário',
    loadError: 'Usuário não encontrado ou indisponível.',
    tabs: {
      overview: 'Visão geral',
      orgs: 'Orgs',
      devices: 'Devices',
      licenses: 'Licenses',
      sessions: 'Atividade de sessão',
      audit: 'Auditoria administrativa',
    },
    dimensionUnavailable: {
      devices:
        'Devices indisponíveis no momento. Não há evidência para afirmar que a conta possui zero devices.',
      licenses:
        'Licenses indisponíveis no momento. Não há evidência para afirmar que a conta possui zero licenses.',
      sessions:
        'Atividade de sessão indisponível no momento. Não há evidência para afirmar que a conta possui zero sessões.',
    },
  },
  'en-US': {
    breadcrumbAriaLabel: 'Breadcrumb',
    usersBreadcrumb: 'Users',
    userFallbackLabel: 'User',
    loadError: 'User not found or unavailable.',
    tabs: {
      overview: 'Overview',
      orgs: 'Orgs',
      devices: 'Devices',
      licenses: 'Licenses',
      sessions: 'Session activity',
      audit: 'Administrative audit',
    },
    dimensionUnavailable: {
      devices:
        'Devices are currently unavailable. There is no evidence that this account has zero devices.',
      licenses:
        'Licenses are currently unavailable. There is no evidence that this account has zero licenses.',
      sessions:
        'Session activity is currently unavailable. There is no evidence that this account has zero sessions.',
    },
  },
};

export const useUserDetailContent = (): UserDetailContent => useBilingual(USER_DETAIL_CONTENT);
